export default __webpack_public_path__ + "img/chart-box.6b62f70d.svg";